import Axios from "axios";
import { JOBINFO, JOBLIST, JOBSUB } from "../constants/url";
import NProgress from "nprogress"; // 引入nprogress插件
import "nprogress/nprogress.css";

Axios.headers = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
};

async function get(url, type = "get") {
  // axios请求拦截器
  Axios.interceptors.request.use(
    (config) => {
      NProgress.start(); // 设置加载进度条(开始..)
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  // axios响应拦截器
  Axios.interceptors.response.use(
    function (response) {
      NProgress.done(); // 设置加载进度条(结束..)
      return response;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  let result = {
    success: false,
    data: null,
    message: null,
  };
  try {
    let { data } = await Axios.get(url, {
      headers: { "Access-Control-Allow-Origin": "*" },
    });
    result.message = data.message;
    result.data = data.data;
    result.success = data.code === 0;
    if (data.code !== 0) {
      if (type === "get")
        // console.log(data.message)
        result.message = "The operation is in error";
      else result.message = "The jobId can not be found";
    }
  } catch (err) {
    console.log(err);
    result.success = false;
    result.message = err.message;
  }

  return result;
}

export async function jobInfo(jobId) {
  return await get(JOBINFO + "/" + jobId,"jobid");
}

export async function jobListGet() {
  return await get(JOBLIST);
}

export const submitForm = async (dataForm) => {
  // axios请求拦截器
  Axios.interceptors.request.use(
    (config) => {
      NProgress.start(); // 设置加载进度条(开始..)
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  // axios响应拦截器
  Axios.interceptors.response.use(
    function (response) {
      NProgress.done(); // 设置加载进度条(结束..)
      return response;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  let result = { success: false, data: {} };

  try {
    let { data } = await Axios.post(JOBSUB, dataForm, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    });
    if (data.code === 0) {
      result.success = true;
      result.data = data.data;
    } else {
      result.success = false;
    }
  } catch (err) {
    console.log(err);
    result.success = false;
  }

  return result;
};
